var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    id: "SVGRoot",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs604"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.03362
    },
    id: "rect728",
    width: 485.11438,
    height: 266.99393,
    x: 13.575964,
    y: 114.03808,
    ry: 52.823059
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 0.975096
    },
    id: "rect728-5",
    width: 462.79544,
    height: 249.07457,
    x: 25.873035,
    y: 125.13381,
    ry: 49.277828
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.48487
    },
    id: "rect730",
    width: 318.4884,
    height: 434.57236,
    x: 96.084282,
    y: 12.563773,
    ry: 33.147968
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.40663
    },
    id: "rect754",
    width: 346.86755,
    height: 180.95351,
    x: 79.997124,
    y: 124.95551,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.22821
    },
    id: "rect763",
    width: 298.86926,
    height: 167.034,
    x: 106.23619,
    y: 271.99023,
    ry: 35.077141
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.919366
    },
    id: "rect756",
    width: 398.70569,
    height: 55.038021,
    x: 58.237904,
    y: 255.35081,
    ry: 27.519011
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    id: "rect758",
    width: 93.436646,
    height: 37.758644,
    x: 369.90671,
    y: 150.39459,
    ry: 18.879322
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.01575
    },
    id: "rect766",
    width: 307.18896,
    height: 124.79552,
    x: 101.75635,
    y: 20.479265,
    ry: 28.39263
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.06502
    },
    id: "rect800",
    width: 341.99728,
    height: 10.953921,
    x: 92.156693,
    y: 114.14217,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    id: "rect804",
    width: 215.67226,
    height: 23.039173,
    x: 150.39459,
    y: 375.6665,
    ry: 10.239633
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.871576
    },
    id: "rect804-5",
    width: 163.83412,
    height: 23.039173,
    x: 150.07462,
    y: 333.42801,
    ry: 10.239633
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.02d13edc1e6d15eca4325a51a1ce2772.svg";
export { ForwardRef as ReactComponent };